// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import Container from './BrandEngageCardContainer';
import {
  requestBrandEngageSearchResults,
  requestBrandEngageAddResponse,
  requestBrandEngageDismissContent,
} from './brandEngageActions';
import HandleRequestError from 'containers/HandleRequestError';
import ContentRequest from 'pages/__components__/ContentRequest';
import { EmptyCard } from 'components';
import styles from './BrandEngageChannel.scss';
import reducer from './brandEngageReducer';
import saga from './brandEngageSaga';
import { injectReducer, injectSaga } from 'store';
import classnames from 'classnames';
import type {
  BrandEngageType,
  BrandEngageTier,
} from 'containers/channels/types';

injectReducer({
  brandEngage: reducer,
});
injectSaga(saga);

type OwnProps = {
  name: string,
  brandEngageType: BrandEngageType,
  brandEngageTier: BrandEngageTier,
  ugctype: UgcType,
  clientId: Id,
};
type StateProps = {
  requestStatus: RequestStatus,
  items: Array<*>,
  dismissedUgcIds: Set<Id>,
};
type DispatchProps = {
  requestBrandEngageSearchResults: typeof requestBrandEngageSearchResults,
  requestBrandEngageAddResponse: typeof requestBrandEngageAddResponse,
  requestBrandEngageDismissContent: typeof requestBrandEngageDismissContent,
};
type Props = OwnProps & StateProps & DispatchProps;

const RequestErrorMessage = () => (
  <EmptyCard
    title="This channel couldn't load."
    message="An Error occurred while fetching content. If this error persists, contact PowerReviews Support."
  />
);

const isFreeTier = (beType: BrandEngageTier) => beType === 'free';

class BrandEngageChannel extends React.Component<Props, void> {
  componentDidMount() {
    this.props.requestBrandEngageSearchResults({
      clientId: this.props.clientId,
      channelName: this.props.name,
      brandEngageType: this.props.brandEngageType,
    });
  }

  render() {
    return (
      <HandleRequestError
        requestStatus={this.props.requestStatus}
        match={err => typeof err.status === 'number' && err.status >= 400}
        render={RequestErrorMessage}
      >
        <ContentRequest
          requestStatus={this.props.requestStatus}
          render={() => {
            if (
              Array.isArray(this.props.items) &&
              this.props.items.length === 0
            ) {
              return (
                <div className="flex flex-column">
                  <div className="center tc mt4">
                    <EmptyCard.Title>No Content</EmptyCard.Title>
                    <EmptyCard.Message>
                      This channel does not have any content.
                    </EmptyCard.Message>
                  </div>
                </div>
              );
            }
            return (
              <React.Fragment>
                {this.props.items.length > 1 && (
                  <div style={{ margin: '-1em 0 -0.5em' }}>
                    <span className="bg-silver white br-pill f6 pv1 ph2">
                      {this.props.items.length} items
                    </span>
                  </div>
                )}
                {this.props.items.map(item => {
                  const containerClass = classnames('mv4', {
                    [styles.brandEngageChannelCardDismissed]: this.props.dismissedUgcIds.has(
                      item.ugc.ugc_id
                    ),
                  });
                  return (
                    <div key={item.ugc.ugc_id} className={containerClass}>
                      <Container
                        clientId={this.props.clientId}
                        product={item.subject}
                        observations={item.observations}
                        readonly={
                          (isFreeTier(this.props.brandEngageTier) &&
                            this.props.ugctype === 'Review') ||
                          undefined
                        }
                        ugc={item.ugc}
                        status={this.props.requestStatus}
                        brandCatalogId={item.brand_catalog_id}
                        brandEngageResponseStatus={item.responseRequestStatus}
                        dismissRequestStatus={item.dismissRequestStatus}
                        requestBrandEngageAddResponse={
                          this.props.requestBrandEngageAddResponse
                        }
                        requestBrandEngageDismissContent={
                          this.props.requestBrandEngageDismissContent
                        }
                      />
                    </div>
                  );
                })}
              </React.Fragment>
            );
          }}
        />
      </HandleRequestError>
    );
  }
}

function mapStateToProps(state: *): StateProps {
  const {
    ugcIds,
    data,
    responseRequestStatus,
    dismissRequestStatus,
    dismissedUgcIds,
  } = state.brandEngage;
  const items = ugcIds.reduce((acc, ugcId) => {
    const item = data.get(ugcId);
    if (item) {
      item.responseRequestStatus = responseRequestStatus.get(ugcId);
      item.dismissRequestStatus = dismissRequestStatus.get(ugcId);
      acc.push(item);
    }
    return acc;
  }, []);

  return {
    requestStatus: state.brandEngage.requestStatus,
    dismissedUgcIds,
    items,
  };
}

const mapDispatchToProps = {
  requestBrandEngageSearchResults,
  requestBrandEngageAddResponse,
  requestBrandEngageDismissContent,
};

export default connect(mapStateToProps, mapDispatchToProps)(BrandEngageChannel);



// WEBPACK FOOTER //
// ./src/containers/brand-engage/BrandEngageChannel.js